<button mat-dialog-close class="close-button" mat-icon-button>
    <mat-icon class="close-icon" color="warn">close </mat-icon>
</button>

<h2 mat-dialog-title [ngClass]="{ hidden: titleHidden }">{{ title }}</h2>

<ng-content></ng-content>
